import React, { Fragment } from "react";
import { GallerySection } from "../components/Gallery/GallerySection";
import { PageHero } from "../components/Global/PageHero";
import { BackToTop } from "../templates/BackToTop";

const MEDIA_LOGO =
  "https://rentnowltd.s3.us-east-2.amazonaws.com/salvation/salv_media_logo.PNG";
const GOLD = "#ffc000";

export const Gallery = () => (
  <Fragment>
    <PageHero
      eyebrow="Church Media"
      title="Our"
      highlight="Gallery"
      subtitle="Check out our recaps from events and church activities."
      extra={
        <div className="flex flex-col items-center gap-2">
          <div
            className="flex items-center gap-3 px-5 py-2 rounded-full"
            style={{
              background: "rgba(255,255,255,0.08)",
              border: `1px solid ${GOLD}44`,
              backdropFilter: "blur(6px)",
            }}
          >
            <img
              src={MEDIA_LOGO}
              alt="Salvation Media"
              style={{
                height: 32,
                width: "auto",
                objectFit: "contain",
                // filter: "brightness(0) invert(1)",
              }}
            />
            {/* <span
              className="font-abel uppercase tracking-widest text-xs"
              style={{ color: GOLD }}
            >
              Salvation Media
            </span> */}
          </div>
        </div>
      }
    />
    <GallerySection />
    <BackToTop />
  </Fragment>
);
